export default __webpack_public_path__ + "static/media/ttm1.2e619589.png";